import {
    AttachmentFullViewState,
    startFakeProgressIndicator,
    getSaveToCloudEstimatedCompleteTimeInMS,
    setActionCompletePercent,
    convertClassicToCloudy,
    getAttachmentSharingInformationForODB,
    stopFakeProgressIndicator,
} from 'owa-attachment-full-data';
import { AttachmentModel, lazyGetAttachment } from 'owa-attachment-model-store';
import type { AttachmentType } from 'owa-attachment-well-data';
import type ItemId from 'owa-service/lib/contract/ItemId';

export function convertClassicToCloudyForSonoraSuggestion(
    attachment: AttachmentFullViewState,
    parentItemId: ItemId,
    replaceAttachmentHandler: (
        attachmentViewState: AttachmentFullViewState,
        attachmentType: AttachmentType,
        isReadOnly: boolean,
        uploadCompleted: boolean
    ) => void
) {
    startFakeProgressIndicator(
        getSaveToCloudEstimatedCompleteTimeInMS(attachment.attachmentId),
        0.1,
        (completePercent: number) => {
            setActionCompletePercent(attachment, completePercent);
        },
        attachment.attachmentId
    );
    convertClassicToCloudy(
        attachment,
        parentItemId,
        async (succeeded: boolean, attachmentType: AttachmentType) => {
            if (succeeded) {
                replaceAttachmentHandler(
                    attachment,
                    attachmentType,
                    false /* isReadOnly */,
                    true /* uploadCompleted */
                );

                // We must call getAttachment after replaceAttachmentHandler so that we get the
                // sharing information for the new attachment, not the one that was already replaced.
                const getAttachment = await lazyGetAttachment.import();
                if (attachmentType.AttachmentId) {
                    const attachmentModel: AttachmentModel = getAttachment(
                        attachmentType.AttachmentId
                    );
                    getAttachmentSharingInformationForODB(attachmentModel);
                }
            } else {
                stopFakeProgressIndicator(attachment.attachmentId, succeeded);
            }
        }
    );
}
